export function isMobileApp() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem("is_mobile_app") === "true";
  } catch {
    return false;
  }
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches === true ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true
  );
}

export function isInAppBrowser() {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  const url = window.location.href;
  return (
    /FBAN|FBAV|Instagram|TikTok|Line|WhatsApp|WeChat/i.test(ua) ||
    /fb_iab|tiktokbrowser|instagram|line|whatsapp|wechat/i.test(ua) ||
    url.includes("fbclid") ||
    url.includes("ttclid")
  );
}

export function isIos() {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua) && !/CriOS|FxiOS|EdgiOS/i.test(ua);
}

export function getBrowserContext() {
  if (typeof window === "undefined") {
    return { standalone: false, inApp: false, userAgent: "" };
  }
  return {
    standalone: isStandalone(),
    inApp: isInAppBrowser(),
    isIos: isIos(),
    userAgent: window.navigator.userAgent,
  };
}
